import React, { useState, useEffect } from 'react';
import moment from 'moment'
import DateFnsUtils from '@date-io/moment';
import { makeStyles } from '@material-ui/styles';
import { ESPECIALIDADITEMS, MEMBERSHIP_TYPE, MEMBERSHIP_STATUS } from '../../../utils/ConstantsMain';
import { TextField, Grid, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import './FilterLawyerFirm.scss'

moment.updateLocale('es', {
    week: {
        dow: 7
    },
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
    weekdaysShort: 'DO_LU_MA_MI_JU_VI_SA'.split('_'),
})

const useStyles = makeStyles({
    textField: {
        maxWidth: 256,
        margin: '0 24px 56px 0',
        height: 48,
        padding: 0,
    },
    cleanFilter: {
        color: '#10587f',
        fontSize: 16,
        fontWeight: 'bold',
        textTransform: 'inherit',
    },
    buttons: {
        margin: '24px 0 0',
        display: 'flex',
        justifyContent: 'space-between'
    },
    mainButtons: {
        display: 'flex',
    },
    mainLinkStyle: {
        margin: '0 40px 0 0',
    },
    mainButtonStyle: {
        minWidth: 240,
    },
    linkStyle: {
        margin: '0 60px 0 0'
    },
    buttonStyle: {
        minWidth: 168,
    },
    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    inputLabelShrink: {
        transform: 'translate(14px, -6px) scale(0.75)',
        backgroundColor: '#fff',
        zIndex: 10,
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
})

const FilterLawyerFirmForm = (props) => {

    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
        setFieldValue,
        handleReset,
        searchEvery,
        handleFlagEvery,
        showEvery,
    } = props;

    const classes = useStyles()

    const [startDate, setStartDate] = useState(null);

    const handleStartDateChange = (date) => {
        setStartDate(date);
        setFieldValue('startDate', date)
    };

    const [lastDate, setLastDate] = useState(null);

    const handleLastDateChange = (date) => {
        setLastDate(date);
        setFieldValue('lastDate', date)
    };

    const searchAll = () => {
        handleFlagEvery(true)
        searchEvery()
    }

    useEffect(() => {
        if (!values.startDate) {
            setStartDate(null);
        }
        if (!values.lastDate) {
            setLastDate(null);
        }
    }, [values.startDate, values.lastDate])

    return (
        <form className='filterLawyerFirmForm'>
            <Grid
                container
                direction='row'
            >
                <TextField
                    label="Nombre"
                    id="name"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name ? values.name : ''}
                    helperText={
                        touched.name && errors.name
                        ? errors.name
                        : ''
                    }
                    error={touched.name && errors.name ? true : false}
                    className={classes.textField}
                    fullWidth
                />

                <TextField
                    label="Correo electrónico"
                    id="email"
                    type="text"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email ? values.email : ''}
                    helperText={
                        touched.email && errors.email
                        ? errors.email
                        : ''
                    }
                    error={touched.email && errors.email ? true : false}
                    className={classes.textField}
                    fullWidth
                />

                <FormControl
                    classes={{ root: classes.textField }}
                    variant="outlined"
                    error={touched.specialty && errors.specialty ? true : false}
                >
                    <InputLabel
                        htmlFor="select-multiple-checkbox"
                        classes={{
                            root: classes.inputLabelRoot,
                            shrink: classes.inputLabelShrink,
                        }}
                    >
                        {'Área de práctica'}
                    </InputLabel>
                    <Select
                        id='specialty'
                        name='specialty'
                        value={values.specialty ? values.specialty : []}
                        onChange={handleChange}
                    >
                        <MenuItem value={''}>
                            Ninguno
                        </MenuItem>
                        {ESPECIALIDADITEMS && ESPECIALIDADITEMS.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                    {touched.specialty && errors.specialty ? (
                        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
                            {errors.specialty}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>
            </Grid>

            <Grid
                container
                direction='row'
            >
                <FormControl
                    classes={{ root: classes.textField }}
                    variant="outlined"
                    error={touched.membershipType && errors.membershipType ? true : false}
                >
                    <InputLabel
                        htmlFor="select-multiple-checkbox"
                        classes={{
                            root: classes.inputLabelRoot,
                            shrink: classes.inputLabelShrink,
                        }}
                    >
                        {'Tipo de membresía'}
                    </InputLabel>
                    <Select
                        id='membershipType'
                        name='membershipType'
                        value={values.membershipType ? values.membershipType : ''}
                        onChange={handleChange}
                    >
                        {MEMBERSHIP_TYPE && MEMBERSHIP_TYPE.map((item, index) => (
                            <MenuItem key={index} value={item.value}>
                                {item.name}
                            </MenuItem> 
                        ))}
                    </Select>
                    {touched.membershipType && errors.membershipType ? (
                        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
                            {errors.membershipType}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>

                <FormControl
                    classes={{ root: classes.textField }}
                    variant="outlined"
                    error={touched.membershipStatus && errors.membershipStatus ? true : false}
                >
                    <InputLabel
                        htmlFor="select-multiple-checkbox"
                        classes={{
                            root: classes.inputLabelRoot,
                            shrink: classes.inputLabelShrink,
                        }}
                    >
                        {'Estatus de la membresía'}
                    </InputLabel>
                    <Select
                        id='membershipStatus'
                        name='membershipStatus'
                        value={values.membershipStatus ? values.membershipStatus : []}
                        onChange={handleChange}
                    >
                        {MEMBERSHIP_STATUS && MEMBERSHIP_STATUS.map((item, index) => (
                            <MenuItem key={index} value={item.value}>
                                {item.name}
                            </MenuItem> 
                        ))}
                    </Select>
                    {touched.membershipStatus && errors.membershipStatus ? (
                        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
                            {errors.membershipStatus}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>
            </Grid>

            <Grid
                container
                direction='row'
            >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableToolbar
                        inputVariant='outlined'
                        name='startDate'
                        variant="inline"
                        format="DD/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="Fecha de inicio"
                        value={startDate}
                        onChange={handleStartDateChange}
                        className={classes.textField}
                        invalidDateMessage='Fecha inválida'
                        maxDateMessage='Fecha más grande que la actual'
                        minDateMessage='Fecha mucho más pequeña que la actual'
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        keyboardIcon={
                            <img
                                src='/img/admin/calendar.svg'
                                alt='calendar-icon'
                            />
                        }
                    />

                    <KeyboardDatePicker
                        disableToolbar
                        inputVariant='outlined'
                        name='lastDate'
                        variant="inline"
                        format="DD/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="Fecha de término"
                        value={lastDate}
                        onChange={handleLastDateChange}
                        className={classes.textField}
                        invalidDateMessage='Fecha inválida'
                        maxDateMessage='Fecha más grande que la actual'
                        minDateMessage='Fecha mucho más pequeña que la actual'
                        minDate={values.startDate && values.startDate}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        keyboardIcon={
                            <img
                                src='/img/admin/calendar.svg'
                                alt='calendar-icon'
                            />
                        }
                    />
                </MuiPickersUtilsProvider>
            </Grid>

            <div className={classes.buttons}>
                <div className={classes.mainButtons}>
                    <ButtonBase
                        type="submit"
                        onClick={handleSubmit}
                        variant="primary"
                        disabled={!isValid}
                        linkStyle={classes.mainLinkStyle}
                        buttonStyle={classes.mainButtonStyle}
                    >
                        Realizar búsqueda
                    </ButtonBase>

                    <Button
                        type='button'
                        component='span'
                        onClick={handleReset}
                        className={classes.cleanFilter}
                    >
                        Limpiar filtro
                    </Button>
                </div>

                {showEvery &&
                    <ButtonBase
                        type="button"
                        onClick={searchAll}
                        variant="primaryOutlined"
                        linkStyle={classes.linkStyle}
                        buttonStyle={classes.buttonStyle}
                        disabled={false}
                    >
                        Mostrar todos
                    </ButtonBase>
                }
            </div>

        </form>
    )
}

export default FilterLawyerFirmForm
